const Menu = [
  {
    label: "Home",
    pathname: "/admin/home"
  },
  {
    label: "Usuários",
    pathname: "/admin/users"
  },
  {
    label: "Papers",
    pathname: "/admin/papers"
  },
  {
    label: "Reviews",
    pathname: "/admin/reviews"
  },
  {
    label: "Logout",
    pathname: "/logout"
  },
];

export default Menu;